export default __webpack_public_path__ + "static/media/icon_preparacion_fail.e022d2a5.svg";